import styled, { keyframes } from 'styled-components';

const slide = keyframes`
  to {
    background-position: 100% 0;
  }
`;

export const Loader = styled.div`
  border-radius: 4px;
  width: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    ${({ theme }) => theme.colors.ui03} 50%,
    rgba(255, 255, 255, 0) 100%
  ),
  ${({ theme }) => theme.colors.ui02};
  background-repeat: repeat-y;
  background-size: 20% 100%;
  background-position: 0 0;
  animation: ${slide} 1s infinite;
  &.inline {
    display: inline-block;
  }
`;
